import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Calendar, ExternalLink, Plus, Settings } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { cn } from '../lib/utils';

const GOOGLE_CALENDAR_URL = 'https://calendar.google.com/calendar/u/1?cid=YWRtaW5AZ3NpbWFnaW5nLmNvbS5hdQ';
const GOOGLE_CALENDAR_EMBED_URL = 'https://calendar.google.com/calendar/embed?src=admin%40gsimaging.com.au&ctz=Australia%2FSydney';

const CalendarPage = () => {
  const { isBarbiePink } = useTheme();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold flex items-center gap-3">
            <Calendar className="w-8 h-8 text-primary" />
            Team Calendar
          </h1>
          <p className="text-muted-foreground mt-1">
            View upcoming appointments and photo sessions
          </p>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className={cn("cursor-pointer hover:shadow-md transition-shadow", isBarbiePink && "card-brutalist")}
              onClick={() => window.open('https://calendar.google.com/calendar/r/eventedit', '_blank')}>
          <CardContent className="p-4 flex items-center gap-3">
            <div className="p-2 rounded-lg bg-green-100 dark:bg-green-900/30">
              <Plus className="w-5 h-5 text-green-600 dark:text-green-400" />
            </div>
            <div>
              <p className="font-medium">Create Event</p>
              <p className="text-sm text-muted-foreground">Add new appointment</p>
            </div>
          </CardContent>
        </Card>

        <Card className={cn("cursor-pointer hover:shadow-md transition-shadow", isBarbiePink && "card-brutalist")}
              onClick={() => window.open(GOOGLE_CALENDAR_URL, '_blank')}>
          <CardContent className="p-4 flex items-center gap-3">
            <div className="p-2 rounded-lg bg-blue-100 dark:bg-blue-900/30">
              <ExternalLink className="w-5 h-5 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
              <p className="font-medium">View Full Calendar</p>
              <p className="text-sm text-muted-foreground">Open in new tab</p>
            </div>
          </CardContent>
        </Card>

        <Card className={cn("cursor-pointer hover:shadow-md transition-shadow", isBarbiePink && "card-brutalist")}
              onClick={() => window.open('https://calendar.google.com/calendar/r/settings', '_blank')}>
          <CardContent className="p-4 flex items-center gap-3">
            <div className="p-2 rounded-lg bg-purple-100 dark:bg-purple-900/30">
              <Settings className="w-5 h-5 text-purple-600 dark:text-purple-400" />
            </div>
            <div>
              <p className="font-medium">Calendar Settings</p>
              <p className="text-sm text-muted-foreground">Manage preferences</p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Embedded Calendar */}
      <Card className={cn(isBarbiePink && "card-brutalist")}>
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-primary" />
            G.S Imaging Calendar
          </CardTitle>
          <CardDescription>
            Shared team calendar for photo sessions and appointments
          </CardDescription>
        </CardHeader>
        <CardContent className="p-0">
          <div className="w-full h-[700px] rounded-b-lg overflow-hidden">
            <iframe
              src={GOOGLE_CALENDAR_EMBED_URL}
              style={{ border: 0 }}
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              title="G.S Imaging Team Calendar"
              data-testid="calendar-iframe"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CalendarPage;
